if (!customElements.get('zc-quiz')) {
  // GA4 property of the Google & YouTube app. Once the visitor allows analytics cookies, that app puts gtag on
  // the page, so quiz events join the visitor's GA session; without consent there is no gtag and nothing is sent.
  const GA_MEASUREMENT_ID = 'G-FZR1VDVVK1';

  function track(name, params) {
    if (typeof window.gtag !== 'function') return false;
    window.gtag('event', name, { ...params, send_to: GA_MEASUREMENT_ID });
    return true;
  }

  class ZCQuiz extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.steps = Array.from(this.querySelectorAll('.zc-quiz__question'));
      this.results = Array.from(this.querySelectorAll('.zc-quiz__result'));
      this.answers = [];

      // global.js moves the popover's <modal-dialog> to <body> and toggles its `open` attribute.
      const modal = this.closest('modal-dialog');
      this.placement = modal ? 'popup' : 'page';
      if (modal) {
        new MutationObserver(() => {
          if (modal.hasAttribute('open')) this.track('vat_quiz_open');
        }).observe(modal, { attributes: true, attributeFilter: ['open'] });
      }

      this.addEventListener('click', (event) => {
        const option = event.target.closest('.zc-quiz__option');
        if (option) return this.answer(option.dataset.value === 'yes');
        if (event.target.closest('.zc-quiz__back')) return this.back();
        if (event.target.closest('.zc-quiz__restart')) return this.restart();
        const shopLink = event.target.closest('.zc-quiz__shop');
        if (shopLink) return this.trackShop(event, shopLink);
        const switchButton = event.target.closest('.zc-quiz__switch');
        if (switchButton) this.switchVatMode(switchButton);
      });
    }

    track(name, params = {}) {
      return track(name, { ...params, quiz_placement: this.placement });
    }

    // The link leaves the page before gtag gets to send, so hold the navigation until the hit is out (max 1s).
    trackShop(event, link) {
      const params = { quiz_result: this.mode };
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) {
        return this.track('vat_quiz_shop', params);
      }
      let followed = false;
      const follow = () => {
        if (followed) return;
        followed = true;
        window.location.href = link.href;
      };
      if (!this.track('vat_quiz_shop', { ...params, event_callback: follow })) return;
      event.preventDefault();
      setTimeout(follow, 1000);
    }

    showStep(index) {
      this.results.forEach((result) => (result.hidden = true));
      this.steps.forEach((step, i) => (step.hidden = i !== index));
      this.steps[index].querySelector('.zc-quiz__option')?.focus({ preventScroll: true });
    }

    answer(isBusinessSignal) {
      this.track('vat_quiz_answer', {
        quiz_step: this.answers.length + 1,
        quiz_question: this.steps[this.answers.length].dataset.question,
        quiz_answer: isBusinessSignal ? 'yes' : 'no',
      });
      this.answers.push(isBusinessSignal);
      if (this.answers.length < this.steps.length) this.showStep(this.answers.length);
      else this.showResult();
    }

    back() {
      this.answers.pop();
      this.showStep(this.answers.length);
    }

    showResult() {
      const yes = this.answers.filter(Boolean).length;
      const mode = yes * 2 >= this.steps.length ? 'business' : 'consumer';
      this.mode = mode;
      this.track('vat_quiz_result', { quiz_result: mode });
      this.steps.forEach((step) => (step.hidden = true));
      this.results.forEach((result) => (result.hidden = result.dataset.mode !== mode));
      this.results.find((result) => !result.hidden)?.querySelector('.zc-quiz__result-title')?.focus({ preventScroll: true });
    }

    restart() {
      this.track('vat_quiz_restart', { quiz_result: this.mode });
      this.answers = [];
      this.results.forEach((result) => {
        result.querySelector('.zc-quiz__feedback').hidden = true;
        result.querySelector('.zc-quiz__switch').hidden = false;
      });
      this.showStep(0);
    }

    // The VAT Switch app exposes window.VatSwitch; setMode converts the prices and saves the preference.
    switchVatMode(button) {
      const applied = typeof window.VatSwitch?.setMode === 'function';
      if (applied) window.VatSwitch.setMode(button.dataset.vatMode);
      this.track('vat_quiz_switch', { quiz_result: this.mode, vat_mode: button.dataset.vatMode });
      const feedback = button.closest('.zc-quiz__result').querySelector('.zc-quiz__feedback');
      feedback.textContent = applied ? feedback.dataset.success : feedback.dataset.manual;
      feedback.hidden = false;
      if (applied) {
        button.hidden = true;
        // Keep focus inside the dialog so Esc and the focus trap keep working.
        feedback.focus({ preventScroll: true });
      }
    }
  }

  customElements.define('zc-quiz', ZCQuiz);
}
